import script from "./SparklineChart.vue?vue&type=script&setup=true&lang=js"
export * from "./SparklineChart.vue?vue&type=script&setup=true&lang=js"

import "./SparklineChart.vue?vue&type=style&index=0&id=bc452680&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc452680"]])

export default __exports__